module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__em-attachment-list"
  }, [(_vm.caption) ? _c('p', {
    staticClass: "__em-attachment-list-title mt-color-grey-lv3"
  }, [_vm._v(_vm._s(_vm.caption))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.attachments), function(file, index) {
    return _c('mt-cell', {
      attrs: {
        "to": _vm.getPreviewUrl(file),
        "value-align": _vm.textalign,
        "v": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.handleClick(file)
        }
      }
    }, [(!_vm._isImage(file)) ? _c('i', {
      staticClass: "iconfont",
      class: _vm.getTypeIcon(file),
      attrs: {
        "slot": "icon"
      },
      slot: "icon"
    }) : _vm._e(), _vm._v(" "), (_vm._isImage(file)) ? _c('img', {
      staticClass: "__em-img-icon",
      attrs: {
        "slot": "icon",
        "src": file.fileUrl
      },
      slot: "icon"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "__em-file-info",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('p', {
      staticClass: "__em-file-info_name"
    }, [_vm._v(_vm._s(_vm.param.fileName ? (_vm.param.fileName + (index + 1)) : file.name))]), _vm._v(" "), _c('p', {
      staticClass: "__em-file-info_size"
    }, [_vm._v(_vm._s(_vm.getFileSize(file)))])])])
  }), _vm._v(" "), (!_vm.attachments || !_vm.attachments.length) ? _c('p', {
    staticClass: "__em-attachment-list-title mt-color-grey-lv3"
  }, [_vm._v("暂无数据")]) : _vm._e()], 2)
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./src/components/emapm-form/emapComponents/emAttachmentList.vue